import React from 'react';

import Unauthorized from 'containers/Error/Pages/Unauthorized/Unauthorized';

import SecureRoute from '../SecureRoute';
import { UserRouteProps } from './types';

const UserRoute: React.FC<UserRouteProps> = ({ children, isAuthorizedUser, onUnauthorizedRedirectProducts }) => (
  <SecureRoute
    isAuthorized={(session) => !!session.user && isAuthorizedUser(session.user)}
    redirectComponent={Unauthorized}
    onUnauthorizedRedirectProducts={onUnauthorizedRedirectProducts}
  >
    {children}
  </SecureRoute>
);

export default UserRoute;
